import { render, staticRenderFns } from "./CustomersCard.vue?vue&type=template&id=5bd35010&scoped=true&"
import script from "./CustomersCard.vue?vue&type=script&lang=js&"
export * from "./CustomersCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomersCard.vue?vue&type=style&index=0&id=5bd35010&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd35010",
  null
  
)

export default component.exports